export const agentsFilterInitialValues = {
	fullName: "",
	agentOffice: "",
	role: "",
	managers: "",
	businessUnit: "",
	status: "",
};
